export const GITHUB_URL = 'https://github.com/Springdale-Robotics/basis';

export const INSTALL_SNIPPET = `git clone https://github.com/Springdale-Robotics/basis
cd basis
sudo bash backend/deploy/native/install.sh --source "$(pwd)"`;
